const API_BASE_URL = process.env.NODE_ENV === 'development'
    ? `http://${window.location.hostname}:3001`
    : 'https://port-0-shortseng-server-mjrzyaqvf344734b.sel3.cloudtype.app';

const DATA_BASE_URL = process.env.NODE_ENV === 'development'
    ? `http://${window.location.hostname}:3001`
    : 'https://shortseng.soocoolkim.workers.dev';

export { API_BASE_URL, DATA_BASE_URL };
export default API_BASE_URL;
